import { Lock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { api } from '@/lib/api';

/**
 * /tenant-suspended — порт frontend/src/app/tenant-suspended/page.tsx.
 *
 * Standalone-страница (БЕЗ AppShell). Показывается когда tenant в state=suspended:
 * api.ts при 401+detail=tenant_suspended редиректит сюда (см. lib/api.ts).
 */
export function TenantSuspendedPage() {
  const handleLogout = async () => {
    try {
      await api.post('/api/v1/auth/logout');
    } catch {
      /* ignore */
    }
    window.location.href = '/login';
  };

  return (
    <div className="min-h-dvh flex items-center justify-center bg-secondary/40 p-6">
      <Card className="w-full max-w-lg">
        <CardContent className="pt-8 pb-6 text-center space-y-4">
          <div className="mx-auto w-14 h-14 rounded-full bg-destructive/10 flex items-center justify-center">
            <Lock className="h-7 w-7 text-destructive" />
          </div>
          <h1 className="text-xl font-semibold">
            Доступ к компании приостановлен
          </h1>
          <div className="text-sm text-muted-foreground space-y-2">
            <p>Оплата просрочена, и доступ был приостановлен.</p>
            <p>
              Обратитесь к администратору платформы для восстановления доступа.
            </p>
          </div>
          <div className="pt-2">
            <Button onClick={handleLogout}>Выйти</Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default TenantSuspendedPage;
